var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-cover-navbar"},[_c('MainBanner'),_c('router-view'),_c('BookingSection'),_c('FixedButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }